import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./PendingVoteButton.module.css";
import thumbsUp from "./thumbsUp.png";

/**
 * Interactive component, A button that displays when a voting agenda item is in the pending process and when voting is locked. When the user clicks on the button, the user is directed to the Decisions page.
 */
export function PendingVoteButton({ isLocked, onClick, isGrayed }) {
  return (
    <div onClick={isLocked ? null : onClick}>
      <button
        className={classNames(
          styles.imageContainer,
          isLocked ? "" : styles.cursorPointerOnHover,
          isGrayed ? styles.grayBg : styles.gradientBg
        )}
      >
        <div>
          <img
            src={thumbsUp}
            className={classNames(styles.image, styles.thumbsUp)}
          />
          <img
            src={thumbsUp}
            className={classNames(styles.image, styles.thumbsDown)}
          />
        </div>
      </button>
    </div>
  );
}

PendingVoteButton.propTypes = {
  isLocked: PropTypes.bool,
  onClick: PropTypes.func,
  isGrayed: PropTypes.bool,
};
